import React from 'react';
import merge_ticket from './merge.svg';
import split_ticket from './split.svg';
import styled from 'styled-components';
import { get } from 'lodash';
import { Text } from '@fozito/common-ui';

export enum TicketButtonTypes {
  MERGE_TICKET = 'MERGE_TICKET',
  SPLIT_TICKET = 'SPLIT_TICKET',
}
const configs = {
  [TicketButtonTypes.MERGE_TICKET]: {
    icon: merge_ticket,
    label: 'Merge Ticket',
  },
  [TicketButtonTypes.SPLIT_TICKET]: {
    icon: split_ticket,
    label: 'Split Ticket',
  },
};
type Props = {
  type: TicketButtonTypes,
  onClick?: () => void;
};
const TicketButton = ({ type, onClick }: Props) => {
  const config = get(configs, type);
  if (!config) return null;

  return (
    <Container type='button' onClick={onClick}>
      <img src={config.icon} alt={config.label} style={{ width: 'auto', height: 24 }} />
      <Text content_content_3_16_semibold text_center color_text_5>{config.label}</Text>
    </Container>
  );
};

export default TicketButton;

const Container = styled.button`
display: flex;
padding: 0 8px;
justify-content: center;
align-items: center;
gap: 4px;
flex: 1 0 0;
border-radius: 4px;
background: #FFF;
box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;

&:hover,
  &:active {
    opacity: 0.8;
    transform: scale(1.05);
    transition: all 0.1s;
  }

  &:disabled {
    opacity: 0.7;
    &:hover,
    &:active {
      opacity: 1;
      cursor: not-allowed;
      transform: none;
      transition: none;
    }
  }
`;